// Centralized route builders and navigation helpers

import { rememberOpenAuthModal } from '../components/auth/authModalStorage';

export const paths = {
    appLanding: () => `/app_landing`,
    profile: () => `/profile`,
    pricingSelection: () => `/tariff-selection`,

    projects: () => `/services/app/projects`,

    shop: (projectId) => `/services/app/shop/${projectId}`,
    shopSettings: (projectId) => `/services/app/shop/${projectId}/settings`,

    theme: (projectId) => `/services/app/theme/${projectId}`,
    notifications: (projectId) => `/services/app/notifications/${projectId}`,
    orders: (projectId) => `/services/app/orders/${projectId}`,

    productsNew: (projectId) => `/services/app/products/${projectId}/new`,
    productEdit: (projectId, productId) => `/services/app/products/${projectId}/${productId}/edit`,

    settings: (projectId) => `/services/app/settings/${projectId}`,

    editor: (projectId) => `/services/app/editor/${projectId}`,
    editorScreen: (projectId, screenId) => `/services/app/editor/${projectId}/screen/${screenId}`,

    templates: () => `/services/app/templates`,
    templateNew: () => `/services/app/templates/new`,
    templateEdit: (templateId) => `/services/app/templates/${templateId}/edit`,
    templateEditScreen: (templateId, screenId) => `/services/app/templates/${templateId}/edit/screen/${screenId}`,
    templatePreview: (templateId) => `/services/app/templates/${templateId}/preview`,

    previewProject: (projectId) => `/services/app/preview/${projectId}`,
    analytics: (projectId) => `/services/app/analytics/${projectId}`,

    newProject: () => `/services/app/new`,

    affiliateProgram: () => `/affiliate`,

    // Non-prefixed or miniapp routes (left intact)
    auth: () => `/?auth=login`,
    appView: (projectId, query = '') => `/app/${projectId}/view${query || ''}`,
    appMobileSettings: (projectId) => `/app/${projectId}/mobile-settings`,
    appSettings: (projectId) => `/app/${projectId}/settings`,
    appEntry: (projectId) => `/app/${projectId}`,

    dev: () => `/dev`,
};

export const go = {
    projects: (navigate, opts) => navigate(paths.projects(), opts),
    shop: (navigate, projectId, opts) => navigate(paths.shop(projectId), opts),
    shopSettings: (navigate, projectId, opts) => navigate(paths.shopSettings(projectId), opts),
    theme: (navigate, projectId, opts) => navigate(paths.theme(projectId), opts),
    notifications: (navigate, projectId, opts) => navigate(paths.notifications(projectId), opts),
    orders: (navigate, projectId, opts) => navigate(paths.orders(projectId), opts),
    productsNew: (navigate, projectId, opts) => navigate(paths.productsNew(projectId), opts),
    productEdit: (navigate, projectId, productId, opts) => navigate(paths.productEdit(projectId, productId), opts),
    settings: (navigate, projectId, opts) => navigate(paths.settings(projectId), opts),
    editor: (navigate, projectId, opts) => navigate(paths.editor(projectId), opts),
    editorScreen: (navigate, projectId, screenId, opts) => navigate(paths.editorScreen(projectId, screenId), opts),
    templates: (navigate, opts) => navigate(paths.templates(), opts),
    templateNew: (navigate, opts) => navigate(paths.templateNew(), opts),
    templateEdit: (navigate, templateId, opts) => navigate(paths.templateEdit(templateId), opts),
    templateEditScreen: (navigate, templateId, screenId, opts) => navigate(paths.templateEditScreen(templateId, screenId), opts),
    templatePreview: (navigate, templateId, opts) => navigate(paths.templatePreview(templateId), opts),
    previewProject: (navigate, projectId, opts) => navigate(paths.previewProject(projectId), opts),
    analytics: (navigate, projectId, opts) => navigate(paths.analytics(projectId), opts),
    newProject: (navigate, opts) => navigate(paths.newProject(), opts),
    auth: (navigate, opts = {}) => {
        rememberOpenAuthModal('login');
        return navigate('/?auth=login', {
            ...opts,
            state: { ...opts.state, openAuth: 'login' },
        });
    },
    appView: (navigate, projectId, query = '', opts) => navigate(paths.appView(projectId, query), opts),
    appMobileSettings: (navigate, projectId, opts) => navigate(paths.appMobileSettings(projectId), opts),
    appSettings: (navigate, projectId, opts) => navigate(paths.appSettings(projectId), opts),
    appEntry: (navigate, projectId, opts) => navigate(paths.appEntry(projectId), opts),
    affiliateProgram: (navigate, opts) => navigate(paths.affiliateProgram(), opts),
    dev: (navigate, opts) => navigate(paths.dev(), opts),
};
